// export const primaryColor = "#f89ca3";
// export const primaryColor = "#ff401e";
export const primaryColor = "#008DB8";
export const lightColor = "#5CD9FF";
export const textColor = "#000";
export const secondaryColor = "#777";
